import React from "react";
import { FaHeartbeat, FaStar, FaHandsHelping, FaUserCheck, FaNetworkWired, FaLightbulb } from "react-icons/fa";
import { motion } from "framer-motion";

export default function CompetitiveEdge() {
  return (
    <div className="  min-h-screen rounded-lg mt-4  py-10 px-4 sm:px-8 lg:px-16">

      {/* Section Header */}
      <div className="text-center mb-5">
        <h1 className="text-[30px]  font-extrabold text-center bg-gradient-to-r from-[#2a627a] to-transparent text-gray-800 rounded-xl mb-6">
          Why Choose <span className="text-[#2a627a]">HIKEHEALTH GS ? </span>
        </h1>
        <p className="text-md text-gray-800">
          We bring innovation, precision, and care to transform healthcare IT into a seamless experience.
        </p>
      </div>

      {/* Feature Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 w-full">
        <FeatureCard
          icon={<FaHeartbeat className="text-[#2a627a]" />}
          title="Healthcare-Focused"
          description="Tailored healthcare IT solutions designed to enhance patient care and operational efficiency."
        />
        <FeatureCard
          icon={<FaStar className="text-[#2a627a]" />}
          title="Commitment to Quality"
          description="We adhere to the highest industry standards, ensuring secure & reliable healthcare technology."
        />
        <FeatureCard
          icon={<FaHandsHelping className="text-[#2a627a]" />}
          title="Full-Service Partner"
          description="We provide end-to-end healthcare IT solutions from consultation to implementation & support."
        />
        <FeatureCard
          icon={<FaUserCheck className="text-[#2a627a]" />}
          title="Customer Satisfaction"
          description="Our customer-first approach ensures seamless, personalized support and problem-solving."
        />
        <FeatureCard
          icon={<FaNetworkWired className="text-[#2a627a]" />}
          title="Strategic Partnerships"
          description="We collaborate with leading healthcare innovators to bring cutting-edge solutions to you."
        />
        <FeatureCard
          icon={<FaLightbulb className="text-[#2a627a]" />}
          title="Innovation-Driven"
          description="We embrace emerging technologies like AI & blockchain to drive the future of healthcare IT."
        />
      </div>
    </div>
  );
}

// Feature Card Component with Hover & 3D Effects
const FeatureCard = ({ icon, title, description }) => (
  <motion.div
    whileHover={{
      scale: 1.05,
      rotateY: 10,
      rotateX: 5,
      transition: { duration: 0.3 },
    }}
    whileTap={{ scale: 0.98 }}
    style={{ perspective: 1000 }}
    // className="relative flex flex-col items-center bg-[#03ab3b] bg-opacity-70 hover:bg-[#03ab3b] p-6 rounded-xl border border-[#03ab3b] shadow-lg transition duration-300 hover:shadow-2xl hover:border-[#03ab3b] group"
    className="relative flex flex-col items-center bg-gray-300 bg-opacity-50  hover:bg-gray-300 p-6 rounded-xl border border-[#2a627a] shadow-lg transition duration-300 hover:shadow-2xl hover:border-[#2a627a] group"
  >
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="text-5xl mb-3 group-hover:scale-110 transition-transform duration-300"
    ><motion.div
      className="flex justify-center mb-1"
      whileHover={{
        y: -20, // Moves the icon upwards (pops out)
        scale: 1.2,
        rotateX: 15,
        rotateY: 10,
        transition: { type: "spring", stiffness: 100 },
      }}
      style={{
        position: "relative",
        zIndex: 10, // Ensures the icon appears above the card
        filter: "drop-shadow(0px 10px 10px rgba(0,0,0,0.2))", // Adds a floating shadow
      }}>
        {icon}
      </motion.div>
      <h3 className="text-lg font-bold text-[#2a627a] text-center">{title}</h3>
      <p className="text-black  text-center text-sm mt-2">{description}</p>
    </motion.div>
  </motion.div>
);
